import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import * as React from 'react'
import { FleetService } from '../../api/fleet-service'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

interface UpdateButtonOpts {
  text: string
  updateFn: (vehicleId: string) => Promise<any>
}

const options: Array<UpdateButtonOpts> = [
  { text: 'In Process (delist)', updateFn: FleetService.updateStateToInProcess },
  { text: 'In Listing (list)', updateFn: FleetService.updateStateToInListing },
  { text: 'Sold', updateFn: FleetService.updateStateToSold },
  { text: 'Total Loss', updateFn: FleetService.updateStateToTotalLoss },
]
interface UpdateVehicleStateButtonsProps {
  vehicleId: string
  currentVehicleState: string
  onSuccess: () => void
  onError: (err: Error) => void
}

export default function UpdateVehicleStateButtons(props: UpdateVehicleStateButtonsProps) {
  const { vehicleId, currentVehicleState, onSuccess, onError } = props
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [selectedIndex, setSelectedIndex] = React.useState(currentVehicleState == 'IN_PROCESS' ? 0 : 1)

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)


  const changeStateEnabled = currentVehicleState === 'IN_LISTING' || currentVehicleState === 'IN_PROCESS'

  const handleClick = () => {
    options[selectedIndex].updateFn(vehicleId)
      .then(onSuccess)
      .catch(onError)
  }

  const handleMenuItemClick = (
    _event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index)
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }

    setOpen(false)
  }

  return (
    <React.Fragment>
      <div>
        {!changeStateEnabled && (
          <Typography>Current state does not allow manual changes.</Typography>
        )}
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="Button group with a nested menu"
          disabled={!changeStateEnabled}
          sx={{
            '& .MuiButton-root': {
              backgroundColor: themeColors.buttonColor,
              color: currentTheme === 'galpin' ? 'black' : 'white',
              '&:hover': {
                backgroundColor: themeColors.buttonHover,
              },
              padding: '3px 9px',
            },
          }}
        >
          <Button onClick={handleClick}>
            {changeStateEnabled ? options[selectedIndex].text : currentVehicleState}
          </Button>
          <Button
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select state of vehicle"
            aria-haspopup="menu"
            onClick={handleToggle}
            style={{ padding: 0, minWidth: '20px' }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
      </div>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={index}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option.text}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  )
}
